module.exports = __webpack_public_path__ + "img/w3_translate_white.9e6f60cb.png";